import React, { useEffect, useState } from 'react'
import { Link } from 'react-router-dom'
import { createPatientApi } from '../../api-helpers/PatientApiHelper';
import '../../assets/scss/custom/home.scss'
import { Constants } from '../../constants/Lookups';
import { useDispatch, useSelector } from 'react-redux';
import { setFilter } from '../../store/slices/filterSlice';
import { RootState } from '../../store';
interface MetricsCounts{
    totalPatientsAssigned: number | "-";
    patientsWithoutUpcomingAppts: number | "-";
}

const MetricsCard = () => {
    const patientApi = createPatientApi();
    const [metricsCounts, setMetricsCounts] = useState<MetricsCounts>({
        totalPatientsAssigned: "-",
        patientsWithoutUpcomingAppts: "-"})
    const dispatch = useDispatch();
    const partnerSelected = useSelector((state:RootState)=>state.user.selected_partner)
    useEffect(()=>{
        (async function(){
            if(partnerSelected?.name){
                const res = await patientApi.patientsControllerGetCountMetrics(partnerSelected?.id?partnerSelected?.id:Constants.ALL);
                setMetricsCounts(res.data);
            }
        })()
    },[partnerSelected])
    const setPatientFilter = (value?:string) => {
        if(value){
            dispatch(setFilter({[Constants.COACH_FILTER_KEY]:Constants.COACH_ME,[Constants.UPCOMING_APPTS_FILTER_KEY]:value,[Constants.PROGRAM_FILTER_KEY]:Constants.ALL}))
        }else{
            dispatch(setFilter({[Constants.COACH_FILTER_KEY]:Constants.COACH_ME,[Constants.PROGRAM_FILTER_KEY]:Constants.ALL}))
        }
    }
  return (
    <div className=' d-flex flex-column flex-lg-row gap-3 align-items-center justify-content-center'>
        <div className="sidebar__content bg-blue-5 py-3 rounded-4 w-100">
            <div className='d-flex flex-column align-items-center justify-content-center'> 
                <h5 className="text-primary fs-14 m-0">Total <b>Assigned</b> Patients:</h5>
                    <div className='fs-20 fw-bold'>{metricsCounts.totalPatientsAssigned}</div>
                    <Link onClick={()=>setPatientFilter()} to="/patients" className="fs-13 link-color">
                        View Member List &gt;
                    </Link>
            </div>
        </div>
        <div className="sidebar__content bg-blue-5 py-3 rounded-4 w-100">
            <div className='d-flex flex-column align-items-center justify-content-center'> 
                <h5 className="text-primary fs-14 m-0">Total <b>Unscheduled</b> Patients:</h5>
                    <div className='fs-20 fw-bold'>{metricsCounts.patientsWithoutUpcomingAppts}</div>
                    <Link onClick={()=>setPatientFilter(Constants.NO_UPCOMING_APPTS)} to="/patients"className="link link-color fs-13">
                    <span >View Member List &gt;</span>
                    </Link>
            </div>
        </div>
    </div>
  )
}

export default MetricsCard
